import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'

import Grid from '@material-ui/core/Grid'
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'

import IconButton from '@material-ui/core/IconButton'
import DeleteIcon from '@material-ui/icons/Delete'

import { connect } from 'react-redux'

import { handleSaveOffice } from '../../actions/offices'
import t from '../../utils/lang/office'

const styles = theme => ({
  root: {
    width: '100%'
  },
  formControl: {
    margin: '0 0 10px',
    width: '100%'
  },
  deleteIcon: {
    fontSize: '20px'
  },
  addFloorButton: {
    marginRight: 'calc(100% - 242px)',
    width: '122px'
  }
});

class SpaceDialog extends Component {
  state = {
    space: []
  }

  componentDidMount() {
    const { data } = this.props

    //console.log('dialog space', data.space)

    this.setState(() => ({
      space: data.space !== null ? data.space : [],
    }))
  }

  handleChangeFloor = (e, index) => {
    const { space } = this.state
    const floor = e.target.value
    const newSpace = [...space]

    newSpace[index].floor = floor

    this.setState({
      space: newSpace,
    })
  }

  handleChangeArea = (e, index) => {
    const { space } = this.state
    const area = e.target.value
    const newSpace = [...space]

    newSpace[index].area = area

    this.setState({
      space: newSpace,
    })
  }

  handleDeleteSpace = (index) => {
    const { space } = this.state
    const newSpace = [...space]

    newSpace.splice(index, 1);

    this.setState({
      space: newSpace,
    })
  }

  handleAddSpace = () => {
    const { space } = this.state
    const newSpace = [...space]

    newSpace.push({ floor: '', area: '' });

    this.setState({
      space: newSpace,
    })
  }

  handleSaveData = e => {
    const { officeId, handleClose, dispatch } = this.props
    const data = JSON.stringify(this.state)

    dispatch(handleSaveOffice(officeId, data))

    handleClose()
  }

  render() {
    const { fullScreen, open, handleClose, classes } = this.props
    const { space } = this.state

    const lang = 'en'

    return (
      <div className={classes.list}>
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">Edit space</DialogTitle>
          <DialogContent>
            <form className={classes.root}>
              {Object.values(space).map((space, index) => (
                <Grid container key={index}>
                  <Grid item xs={5}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        id={`floor[${index}]`}
                        //label={t[lang].floor}
                        placeholder={t[lang].floor}
                        value={space.floor}
                        onChange={(e) => this.handleChangeFloor(e, index)}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={5}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        id={`area[${index}]`}
                        //label={t[lang].area}
                        placeholder={t[lang].area}
                        value={space.area}
                        onChange={(e) => this.handleChangeArea(e, index)}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={1}>
                    <IconButton aria-label="Delete">
                      <DeleteIcon className={classes.deleteIcon} onClick={(e) => this.handleDeleteSpace(index)} />
                    </IconButton>
                  </Grid>
                </Grid>
              ))}
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleAddSpace} color="secondary" className={classes.addFloorButton}>
              Add floor
            </Button>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleSaveData} color="primary" autoFocus>
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

SpaceDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  officeId: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired
};

function mapStateToProps ({ authedUser }) {
  return {
    userId: authedUser.id
  }
}

export default connect(mapStateToProps)(withStyles(styles)(withMobileDialog()(SpaceDialog)))


// WEBPACK FOOTER //
// ./src/components/Offices/SpaceDialog.js